export default function MedicalTemplatePrescriptionForm({ items, handleDelete }) {
    return (<>
        {items.length > 0 && <div className="table-responsive m-0 rounded-bottom">
            <table className="table m-0 rounded-bottom table-striped">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Medicine</th>
                        <th>Strength</th>
                        <th>Form</th>
                        <th>Route</th>
                        <th>Product Type</th>
                        <th>Active Substances</th>
                        <th>Packet Size</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, index) => (
                        <tr key={index}>
                            <td>{item.id || "-"}</td>
                            <td>{item.medicine_name || "-"}</td>
                            <td>{item.strength}{item.unit}</td>
                            <td>{item.pharmaceutical_form || "-"}</td>
                            <td>{item.route || "-"}</td>
                            <td>{item.product_type || "-"}</td>
                            <td>{item.active_substances || "-"}</td>
                            <td>{item.packet_size || "-"}</td>
                            <td>
                                <div
                                    style={{ cursor: "pointer" }}
                                    className="avtar avtar-xs btn-link-secondary deleteIcon"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        if (handleDelete)
                                            handleDelete(index)
                                    }}
                                >
                                    <i className="ti ti-trash f-20" />
                                    <span>Delete</span>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>} {items.length == 0 && (<div className="text-center my-5">
            <h5>No prescriptions found.</h5>
        </div>)}
    </>)
}